<script setup lang="ts">
/** Region viva siempre montada para que los lectores de pantalla anuncien cada aviso. */
import { useUiStore } from "@/stores/ui";

const ui = useUiStore();
</script>

<template>
  <div class="toast-region" aria-live="polite" aria-atomic="true">
    <Transition name="toast">
      <div v-if="ui.toast" class="toast" @click="ui.dismissToast()">{{ ui.toast }}</div>
    </Transition>
  </div>
</template>

<style scoped>
.toast {
  position: fixed;
  left: 50%;
  bottom: calc(24px + var(--safe-bottom));
  transform: translateX(-50%);
  z-index: 30;
  width: max-content;
  max-width: calc(100% - 40px);
  padding: 12px 16px;
  border-radius: var(--radius-lg);
  background: var(--color-neutral-900);
  color: var(--color-bg);
  font-size: 14px;
  box-shadow: var(--shadow-lg);
}
.toast-enter-active,
.toast-leave-active {
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translate(-50%, 8px);
}
</style>
